import React, { FC } from 'react';

export const ReportingIcon: FC = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7H22V9H14V7ZM12 7C12 5.89543 12.8954 5 14 5H22C23.1046 5 24 5.89543 24 7H26C27.1046 7 28 7.89543 28 9V29C28 30.1046 27.1046 31 26 31H10C8.89543 31 8 30.1046 8 29V9C8 7.89543 8.89543 7 10 7L12 7ZM12 9H10L10 29H26V9H24C24 10.1046 23.1046 11 22 11H14C12.8954 11 12 10.1046 12 9ZM23.6585 14.7526C24.0741 14.3889 24.1163 13.7571 23.7526 13.3415C23.3889 12.9259 22.7571 12.8838 22.3415 13.2474L18.9842 16.1851L15.9386 13.6472L12.2929 17.2929C11.9024 17.6834 11.9024 18.3166 12.2929 18.7071C12.6834 19.0976 13.3166 19.0976 13.7071 18.7071L16.0614 16.3529L19.0158 18.8149L23.6585 14.7526ZM13 23C12.4477 23 12 22.5523 12 22C12 21.4477 12.4477 21 13 21H23C23.5523 21 24 21.4477 24 22C24 22.5523 23.5523 23 23 23H13ZM13 27C12.4477 27 12 26.5523 12 26C12 25.4477 12.4477 25 13 25H23C23.5523 25 24 25.4477 24 26C24 26.5523 23.5523 27 23 27H13Z"
        fill="#5577FF"
      />
    </svg>
  );
};
